import { SelectionOptions } from 'coreOld/enums';
import { IPart } from 'partsOld/types';

const PART_NOTE_TYPE_COST = 'cost';

export const mapCreatePartNotesToServer = (
  noteContent: string,
  parts?: IPart[],
  selectionMode?: SelectionOptions,
  filters?: Record<string, any>
) => {
  if (selectionMode === SelectionOptions.FILTERED) {
    return {
      corporatePartNotes: [
        {
          type: PART_NOTE_TYPE_COST,
          content: noteContent,
        },
      ],
      filters,
    };
  }

  return {
    corporatePartNotes: [
      {
        type: PART_NOTE_TYPE_COST,
        content: noteContent,
      },
    ],
    filters: { id: parts.map((part) => part.id) },
  };
};
